export enum NewsMessagesFilterType {
  All = 'All',
  Message = 'Message',
  News = 'News',
  Comment = 'Comment',
  FollowingOrLike = 'IsMyFollowingOrLiked',
  OrganizationIds = 'organizationIds',
}
